<template>
  <component :is="tag" class="detail-label">
    <slot />
  </component>
</template>

<script setup>
/**
 * Le libellé d'une fiche : ce qui NOMME une valeur ou un groupe de valeurs.
 *
 * UN SEUL STYLE DE LIBELLÉ PAR FICHE. Avant lui, une même section empilait le
 * libellé de `DetailItem` (petit, gris, casse normale), des intertitres en
 * petites capitales espacées (« SA PRÉSENTATION »), des sous-libellés en gras
 * (« Alertis ») et des intertitres en capitales grasses (« CE QUI EST EXIGÉ DE
 * TOUT LE MONDE ») — quatre voix pour dire la même chose, « voici ce qui
 * suit ». `DetailItem` le rend au-dessus de sa valeur ; on le pose seul
 * au-dessus d'un groupe de lignes (une liste de pièces, d'accords).
 *
 * `tag` : `DetailItem` le rend en `<label>` (un clic donne le focus au champ).
 */
defineProps({
  tag: { type: String, default: 'span' },
})
</script>

<style scoped>
.detail-label {
  display: block;
  margin: 0 0 2px;
  padding: 0;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-normal);
  font-style: normal;
  line-height: var(--line-height-normal);
  text-transform: none;
  color: var(--color-text-tertiary);
}
</style>
